import { useHead } from '@vueuse/head'

export function useSeo({ title, description, url, image }) {
  const defaultTitle = "Prokuroria e Republikës së Kosovës"
  const defaultDescription = "Faqja zyrtare e sistemit prokurorial në Republikën e Kosovës."
  const defaultImage = "/seo-default.png" // vendose logon ose një foto

  useHead({
    title: title || defaultTitle,
    meta: [
      { name: "description", content: description || defaultDescription },

      // Open Graph (Facebook, Viber, Telegram, LinkedIn)
      { property: "og:title", content: title || defaultTitle },
      { property: "og:description", content: description || defaultDescription },
      { property: "og:type", content: "website" },
      { property: "og:url", content: url || window.location.href },
      { property: "og:image", content: image || defaultImage },

      // Twitter
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: title || defaultTitle },
      { name: "twitter:description", content: description || defaultDescription },
      { name: "twitter:image", content: image || defaultImage },
    ],

    // Canonical
    link: [
      { rel: "canonical", href: url || window.location.href }
    ]
  })
}
